import { makeStyles, Theme } from '@material-ui/core/styles';
export const useStyles = makeStyles((theme: Theme) => ({
  featureSelect: {
    padding: '0 0 12px 0px',
    display: 'flex',
    justifyContent: 'space-between',
    borderTop: '1px solid',
  },
  selction1: {
    padding: '24px 16px 0 0 ',
  },
  selction2: {
    padding: '24px 0 0 16px',
  },
  dateDisplay: { padding: '0 16px 0 0 ' },
  dateDisplay1: { padding: '0 0 0 16px' },
  input: {
    flexGrow: 1,
    fontSize: 16,
  },
  inputText: {
    flexGrow: 1,
    fontSize: 16,
    '& .MuiInput-underline.Mui-disabled:before': {
      borderBottomStyle: 'solid',
    },
  },
}));
